import React from 'react';
import { PropTypes } from 'prop-types';
import { compose, pure } from 'recompose';

const enhance = compose(pure);

const AddressSelector = ({
  activeRef,
  t,
  className,
  address,
  handleClick,
  disabled,
  style,
}) => (
  <button
    type="button"
    className={className}
    onClick={handleClick}
    ref={activeRef}
    disabled={disabled}
    style={style}
    data-e2e="address-selector"
  >
    <div className="address">
      {address.company_name} <>{!!address.label && <> - {address.label}</>}</>
    </div>
    <div className="subaddress">
      {address.address_line}, {address.zipcode}.
      {!!address.contact_name || !!address.contact_phone ? (
        <>
          {} {address.contact_name} {address.contact_phone}
        </>
      ) : (
        <>
          {} {t('no_contact')}
        </>
      )}
    </div>
  </button>
);

AddressSelector.propTypes = {
  activeRef: PropTypes.func,
  className: PropTypes.string,
  t: PropTypes.func,
  address: PropTypes.shape({}),
  handleClick: PropTypes.func,
  style: PropTypes.object,
};

AddressSelector.defaultProps = {
  className: '',
  t: (k) => k,
  address: {},
  handleClick: () => {},
  activeRef: () => {},
};

export default enhance(AddressSelector);
